import Grid from "@material-ui/core/Grid";
import React from "react";
import HeaderBarComponent from "../../../shared/header-bar/header-bar";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import TitleDescriptionComponent from "../../../shared/components/title-description";
import ShareFormComponent from "../shared/share-form";
import MyPrayersResources from "../../../../resources/my-prayers";
import List from "@material-ui/core/List";
import ListItem from "@mui/material/ListItem";
import ImagesCategoriesComponent from "../shared/images-categories";
import LocalStorageResources from "../../../../resources/local-storage";
import { web } from "../../../../environments/environment";
import Snackbar from "@material-ui/core/Snackbar";

class QuickResponseComponent extends React.Component {
  constructor(props) {
    super(props);
    const {
      match: {
        params: { id },
      },
    } = this.props;
    this.state = {
      id,
      categories: [],
      data: [],
      loadData: false,
      selectedCategory: null,
      formSend: false,
      prayer: {},
      dataForm: {
        from: "no-reply@myprayr.com",
        to: null,
        subject: null,
        content: null,
        photo_id: null,
        phone: null,
        message_type: "message",
      },
      imageUrl: null,
      previewUrl: null,
      snackbarOpen: false,
      snackbarMessage: null,
      submitText: "SEND",
      messageChannel: "email",
      backUrl: this.props.location?.state?.backUrl
        ? this.props.location.state.backUrl
        : null,
      fromGroup: this.props.location?.state?.fromGroup
        ? this.props.location.state.fromGroup
        : null,
    };
    this.filterCategories = this.filterCategories.bind(this);
    this.onCloseShareForm = this.onCloseShareForm.bind(this);
    this.loadData = this.loadData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.showForm = this.showForm.bind(this);
    this.showFormWithImage = this.showFormWithImage.bind(this);
    this.menuBackAction = this.menuBackAction.bind(this);
    this.showImages = this.showImages.bind(this);
    this.toggleMessageChannel = this.toggleMessageChannel.bind(this);
  }

  componentDidMount() {
    this.loadPrayer();
    this.loadCategories();
  }

  loadPrayer() {
    const { id } = this.state;
    this.setState({
      isLoading: true,
    });
    MyPrayersResources.get(id).then((data) => {
      if (data.group_id) {
        this.setState({
          fromGroup: { id: data.group_id },
        });
      }
      this.setState({
        prayer: data,
        isLoading: false,
      });
      this.toggleMessageChannel(data.message_type);
    });
  }

  handleChange(evt) {
    const target = evt.target.name;
    const value = evt.target.value;
    this.setState((prevState) => ({
      dataForm: { ...prevState.dataForm, [target]: value },
    }));
  }

  toggleMessageChannel(messageChannel) {
    const { dataForm, prayer } = this.state;
    dataForm.from = "no-reply@myprayr.com";
    dataForm.to = prayer.email;
    dataForm.phone = prayer.phone;
    const userData = LocalStorageResources.getObject("authData").data;
    let buttonText = "";
    switch (messageChannel) {
      case "email":
        buttonText = "SEND";
        break;
      case "sms":
        buttonText = "SEND";
        break;
      case "in-app":
        dataForm.from = `${userData.first_name} ${userData.last_name}`;
        (dataForm.to = messageChannel == "in-app" ? prayer.name : prayer.email),
          (buttonText = "SEND");
        break;
      default:
        buttonText = "SEND";
        break;
    }
    this.setState({
      messageChannel: messageChannel,
      submitText: buttonText,
      dataForm: dataForm,
    });
  }

  submitForm(messageChannel = "email") {
    const { dataForm, prayer, fromGroup, previewUrl } = this.state;
    if (messageChannel == "email" || messageChannel == "in-app") {
      if (!dataForm.to) {
        const snackbarMessage = "Enter recipient";
        this.setState({
          snackbarOpen: true,
          snackbarMessage,
        });
      } else {
        if (!dataForm.subject) {
          const snackbarMessage = "Enter subject";
          this.setState({
            snackbarOpen: true,
            snackbarMessage,
          });
        } else {
          if (!dataForm.content) {
            const snackbarMessage = "Enter content";
            this.setState({
              snackbarOpen: true,
              snackbarMessage,
            });
          } else {
            let sendData = {};
            let payload = {
              subject: dataForm.subject,
              content: dataForm.content,
              photo_id: dataForm.photo_id,
              prayer_id: prayer.id,
              message_type: dataForm.message_type,
            };
            if (messageChannel == "email") {
              (payload.to = dataForm.to), (sendData.email = payload);
              MyPrayersResources.sendMessage(sendData)
                .then((response) => {
                  response.json().then((parsedJson) => {
                    if (parsedJson.errors) {
                      const firstError = `${Object.entries(
                        parsedJson.errors
                      )[0][0].replace("_", " ")} ${
                        Object.entries(parsedJson.errors)[0][1]
                      }`;
                      this.setState({
                        isLoading: false,
                        snackbarOpen: true,
                        snackbarMessage: firstError,
                      });
                    } else {
                      this.props.history.push(
                        !fromGroup
                          ? `/my-prayers`
                          : `/our-prayers/${fromGroup.id}/view-group`,
                        {
                          message: parsedJson.message,
                          fromGroup,
                        }
                      );
                    }
                  });
                })
                .catch(() => {
                  const snackbarMessage = "No update email to prayer";
                  this.setState({
                    snackbarOpen: true,
                    snackbarMessage,
                  });
                });
            } else if (messageChannel == "in-app") {
              (payload.to_user_id = prayer.user_id),
                (sendData.in_app = payload);
              MyPrayersResources.sendMessageInApp(sendData).then(() => {
                this.props.history.push(
                  !fromGroup
                    ? `/my-prayers`
                    : `/our-prayers/${fromGroup.id}/view-group`,
                  {
                    message: "The message has been sent",
                    fromGroup,
                  }
                );
              });
            }
          }
        }
      }
    } else if (messageChannel == "sms") {
      if (!dataForm.phone) {
        const snackbarMessage = "Enter phone";
        this.setState({
          snackbarOpen: true,
          snackbarMessage,
        });
      } else {
        if (!dataForm.content) {
          const snackbarMessage = "Enter content";
          this.setState({
            snackbarOpen: true,
            snackbarMessage,
          });
        } else {
          var prayerData = { prayer: { id: prayer.id, phone: dataForm.phone } };
          if (!prayer.group_id) {
            MyPrayersResources.updatePhone(prayerData)
              .then((response) => {
                response.json().then((parsedJson) => {
                  if (parsedJson.errors) {
                    this.setState({
                      isLoading: false,
                      snackbarOpen: true,
                      snackbarMessage: parsedJson.errors,
                    });
                  } else {
                    const options = {
                      fromGroup,
                    };
                    if (parsedJson.message)
                      options["message"] = parsedJson.message;
                    const imagePreviewUrl = previewUrl
                      ? `${web}${previewUrl}`
                      : "";
                    location.href = `sms:${dataForm.phone};?&body=${dataForm.content} ${imagePreviewUrl}`;
                    this.props.history.push(
                      !fromGroup
                        ? `/my-prayers`
                        : `/our-prayers/${fromGroup.id}/view-group`,
                      options
                    );
                  }
                });
              })
              .catch(() => {
                const snackbarMessage = "No update phone to prayer";
                this.setState({
                  snackbarOpen: true,
                  snackbarMessage,
                });
              });
          } else {
            MyPrayersResources.sendEncouragementSMS(prayer).then(() => {
              const imagePreviewUrl = previewUrl ? `${web}${previewUrl}` : "";
              location.href = `sms:${dataForm.phone};?&body=${dataForm.content} ${imagePreviewUrl}`;
              this.props.history.push(
                !fromGroup
                  ? `/my-prayers`
                  : `/our-prayers/${fromGroup.id}/view-group`,
                {
                  fromGroup,
                }
              );
            });
          }
        }
      }
    }
  }

  showImages() {
    this.setState({
      showImages: true,
      formSend: false,
    });
  }

  loadCategories() {
    this.setState({
      isLoading: true,
    });
    MyPrayersResources.getAllQuickMessages().then((data) => {
      this.setState({
        categories: data,
        isLoading: false,
      });
    });
  }

  showForm(content) {
    const { prayer } = this.state;
    this.setState((prevState) => ({
      dataForm: {
        ...prevState.dataForm,
        subject: content,
        content: content,
        to: prayer.email,
      },
      formSend: true,
      showImages: false,
    }));
  }

  showFormWithImage(data) {
    this.setState((prevState) => ({
      dataForm: {
        ...prevState.dataForm,
        photo_id: data.id,
      },
      imageUrl: data.image_url,
      previewUrl: data.preview_url,
      formSend: true,
      showImages: false,
    }));
  }

  onCloseShareForm() {
    this.setState((prevState) => ({
      dataForm: {
        ...prevState.dataForm,
        photo_id: null,
        subject: null,
        to: null,
        phone: null,
        content: null,
        image: null,
      },
      imageUrl: null,
      previewUrl: null,
      formSend: false,
      showImages: false,
    }));
  }

  onClose() {
    this.setState({ snackbarOpen: false });
  }

  loadData() {
    const { categories, selectedCategory } = this.state;
    if (selectedCategory) {
      this.setState({
        data: categories[selectedCategory],
        loadData: true,
      });
    } else {
      this.setState({
        loadData: false,
        snackbarOpen: true,
        snackbarMessage: "Select a verse",
      });
    }
  }

  renderCategoriesList() {
    const { categories, selectedCategory } = this.state;
    return (
      <Grid item xs={10} style={{ width: "100vh", marginTop: "2vh" }}>
        <div
          style={{
            width: "100%",
            overflowY: "auto",
          }}
        >
          <List>
            {categories.map((item, i) => (
              <ListItem
                selected={selectedCategory == item}
                key={"listItem" + i}
                className="item itemTopics"
                style={{ textAlign: "center", textTransform: "none" }}
                onClick={() => this.showForm(item.content)}
              >
                {item.content}
              </ListItem>
            ))}
          </List>
        </div>
      </Grid>
    );
  }

  filterCategories() {
    this.setState({
      loadData: false,
      showImages: false,
      formSend: false,
      data: [],
    });
  }

  menuBackAction() {
    const { formSend, loadData, prayer, showImages, fromGroup, backUrl } =
      this.state;
    if (formSend) {
      this.onCloseShareForm();
    } else {
      if (loadData) {
        this.filterCategories();
      } else {
        if (showImages) {
          this.setState({
            formSend: true,
            showImages: false,
          });
        } else {
          this.props.history.push(
            backUrl ? backUrl : `/my-prayers/${prayer.id}/view-person/`,
            {
              backUrl: `/my-prayers/${prayer.id}/view-details`,
              fromGroup,
            }
          );
        }
      }
    }
  }

  render() {
    const {
      isLoading,
      loadData,
      formSend,
      prayer,
      dataForm,
      imageUrl,
      previewUrl,
      showImages,
      id,
      snackbarOpen,
      snackbarMessage,
      messageChannel,
      submitText,
    } = this.state;
    return (
      <div>
        {isLoading && (
          <div>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={true}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>
        )}
        {!isLoading && (
          <div>
            <HeaderBarComponent
              showLogo
              showBack
              showBackAction={this.menuBackAction}
              showMenu
              showNotifications
              title={"Prayr Apps"}
            />
            {!loadData && !formSend && !showImages && (
              <div>
                <Grid container direction="column" alignItems="center">
                  <TitleDescriptionComponent
                    title={"Choose a Message"}
                    typeTitle={"titleBody"}
                    description={`It's difficult to find time to let everyone know that they are in your thoughts and prayer, use these quick response templates to get the word out and share His love.`}
                  />
                  {this.renderCategoriesList()}
                </Grid>
              </div>
            )}
            <Snackbar
              open={snackbarOpen}
              autoHideDuration={5000}
              message={snackbarMessage}
              onClose={() => this.onClose()}
            />
          </div>
        )}
        {!isLoading && formSend && !showImages && (
          <ShareFormComponent
            dataForm={dataForm}
            prayer={prayer}
            imageUrl={imageUrl}
            previewUrl={previewUrl}
            showImages={this.showImages}
            onClose={this.onCloseShareForm}
            onSubmit={this.submitForm}
            inputChange={this.handleChange}
            onToggleMessage={this.toggleMessageChannel}
            submitText={submitText}
            messageChannel={messageChannel}
          />
        )}
        {!isLoading && !formSend && showImages && (
          <ImagesCategoriesComponent
            prayerId={id}
            actionImage={this.showFormWithImage}
          />
        )}
      </div>
    );
  }
}

export default QuickResponseComponent;
